import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';
const apiOrigin = new URL(apiBaseUrl).origin;

export const search = async (searchTerm) => {
  try {
    const response = await axios.post(`${apiOrigin}/Search`, { searchTerm });
    return response.data;
  } catch (error) {
    console.error('Search error:', error);
    return {
      isSuccess: false,
      statusCode: error.response?.status || 500,
      resultMessage: 'Arama sırasında bir hata oluştu',
      errors: [error.message],
      data: []
    };
  }
};
